
const apiPath = 'https://localhost:7206'; 

const config = {
  apiPath,
};

export default config;
